/**
 * 文本符号
 * @remarks
 * 常用于文本标注
 */
export class Text {
    constructor() {
        /**
         * 边框宽
         */
        this.lineWidth = 3;
        /**
         * 边框色
         */
        this.strokeStyle = "#ff0000"; //#ffffff
        /**
         * 填充色
         */
        this.fillStyle = "#ffffff"; //#ffffff
        /**
         * X偏移
         */
        this.offsetX = 0;
        /**
         * Y偏移
         */
        this.offsetY = 1;
        /**
         * 周边留白
         */
        this.padding = 5;
        /**
         * 字体颜色
         */
        this.fontColor = "#ff0000";
        /**
         * 字体大小
         */
        this.fontSize = 12;
        /**
         * 字体
         */
        this.fontFamily = "YaHei";
        /**
         * 字体粗细
         */
        this.fontWeight = "Bold";
        /**
         * 放置位置
         */
        this.placement = "BOTTOM"; //BOTTOM TOP LEFT RIGHT
        /**
         * 自动调整位置
         */
        this.auto = false;
        /**
         * 标注点符号的宽度
         */
        this.pointSymbolWidth = 0;
        /**
         * 标注点符号的高度
         */
        this.pointSymbolHeight = 0;
    }
    /**
     * 自动调整位置
     * @remarks 按逆时针方向寻找合适位置
     */
    replacement() {
        if (this.auto) {
            switch (this.placement) {
                case "BOTTOM":
                    this.placement = "RIGHT";
                    break;
                case "RIGHT":
                    this.placement = "TOP";
                    break;
                case "TOP":
                    this.placement = "LEFT";
                    break;
                case "LEFT":
                    this.placement = "BOTTOM";
                    break;
            }
        }
    }
}
